var map = {
	"./ic_sense_breath.png": 2993,
	"./ic_sense_movement.png": 6202,
	"./ic_sense_nature.png": 5718,
	"./ic_sense_pressure.png": 2195,
	"./ic_sense_smell.png": 6023,
	"./ic_sense_sound.png": 4427,
	"./ic_sense_taste.png": 112,
	"./ic_sense_touch.png": 8718
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7729;